export enum Licenses {
    Ferrodo = "fs01167",
    TgInstalacje = "fs01523",
    Hydraulik = "fs01510",
}